<template>
    <transition name="loader">
        <div v-show="showPreLoader" class="pre-loader">
            <svg width="80px" height="40px" viewBox="0 0 80 40" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="30" r="10"  fill="var(--primary-color)" />
                <circle cx="40" cy="30" r="10"  fill="var(--primary-color)" />
                <circle cx="70" cy="30" r="10"  fill="var(--primary-color)" />
            </svg>
        </div>
    </transition>
</template>

<script>

    export default {
        name: "pre-loader",
        data() {
            return {
                showPreLoader: true
            }
        },
        props: {
            status: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.showPreLoader = this.status
        },
        methods: {

        },
        watch: {
            status(val) {
                this.showPreLoader = val
            }
        }
    }
</script>

<style scoped>
    .pre-loader {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--white-color);
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pre-loader svg circle {
        animation: load infinite 1s linear;
    }
    .pre-loader svg circle:nth-child(1) {
        animation-delay: 0;
    }
    .pre-loader svg circle:nth-child(2) {
        animation-delay: .15s;
    }
    .pre-loader svg circle:nth-child(3) {
        animation-delay: .3s;
    }
    @keyframes load {
        0% {
            transform: translateY(0);
        }
        30% {
            transform: translateY(-10px);
        }
        35% {
            transform: translateY(-10px);
        }
        50% {
            transform: translateY(0);
        }
    }
    .loader-enter-active, .loader-leave-active {
        transition: opacity .5s;
    }
    .loader-enter, .loader-leave-to {
        opacity: 0;
    }
</style>
